module.exports = __webpack_public_path__ + "static/img/banner_h5_01_zh.fccf449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_h5_01_zh.png
// module id = tJ0Y
// module chunks = 34